
const { matchPid } = require('../utilities/ProductPage');
const { addCSSLink } = require('../utilities/ScriptStylesheetHelper');

const whiteList = [
    9042,8937,8802,8779,8772,8767,8764, // Laptop 2023
    9439, 9440, 9437 //Laptop 2024
];
whiteList.push(6441);///* AORUS-NB-TEST (for test)*/

const pid = matchPid(...whiteList);

(function(){
    if(!pid){
        return;
    }


    document.querySelector('.section-rgb .row-cols-2')?.classList.remove('row-cols-2');

    var style = document.createElement("link");
    style.href = '/WebPage/999/innergigabyte/css/Fix_Laptop2024_section_rgb.css';
    style.rel = "stylesheet";
    style.type = "text/css";
    document.body.appendChild(style);
})();